(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-nav"]) return;
  try {
    
  if (!customElements.get('faq-nav')) {
    customElements.define(
      'faq-nav',
      class FAQNav extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          const groups = document.querySelectorAll('[data-faq-group]');
          const itemsContainer = this.querySelector('.faq-nav__items');

          groups.forEach((group) => {
            const id = group.id;
            const label = group.getAttribute('data-faq-group') || id;
            if (id) {
              const link = document.createElement('a');
              link.href = `#${id}`;
              link.className = 'faq-nav__item';
              const text = document.createElement('span');
              text.textContent = label;
              link.appendChild(text);
              itemsContainer.appendChild(link);
            }
          });

          this.setAttribute('data-initialized', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero--legacy"]) return;
  try {
    
  if (!customElements.get("hero-carousel")) {
    customElements.define(
      "hero-carousel",
      class HeroCarousel extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute("data-section-id");
        }

        connectedCallback() {
          this.swiperEl = this.querySelector("swiper-container");
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          console.log("select");
          const targetSlide = this.querySelector(`#hero-slide-${event.detail.blockId}`);
          console.log(targetSlide);
          const targetIndex = parseInt(targetSlide.getAttribute("data-index"));
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener("shopify:block:deselect", this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          console.log("deselect");
          this.swiperEl.swiper.slideTo(0, 0);
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    customElements.define(
      'hero-carousel',
      class HeroCarousel extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute('data-section-id');
        }

        connectedCallback() {
          this.swiperEl = this.querySelector('swiper-container');
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          const targetSlide = this.querySelector(`#${event.detail.sectionId}-${event.detail.blockId}`);
          const targetIndex = parseInt(targetSlide.getAttribute('data-index'));
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.swiperEl.swiper.slideTo(0, 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-gallery')) {
    customElements.define(
      'image-gallery',
      class ImageGallery extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute('data-section-id');
        }

        connectedCallback() {
          this.swiperEl = this.querySelector('swiper-container');
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          const targetSlide = this.querySelector(`#${event.detail.sectionId}-${event.detail.blockId}`);
          const targetIndex = parseInt(targetSlide.getAttribute('data-index'));
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.swiperEl.swiper.slideTo(0, 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('intro-marquee')) {
    customElements.define(
      'intro-marquee',
      class IntroMarquee extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          if (Shopify.designMode) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.setAttribute('data-block-selected', '');
          event.target.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.removeAttribute('data-block-selected');
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('sticky-total')) {
    customElements.define(
      'sticky-total',
      class StickyTotal extends HTMLElement {
        constructor() {
          super();
          this.observer = null;
        }

        connectedCallback() {
          // Create trigger element
          const trigger = document.createElement('div');
          trigger.className = 'product__total-trigger';
          this.parentElement.insertBefore(trigger, this);

          // Setup observer
          this.observer = new IntersectionObserver(([entry]) =>
            this.classList.toggle('is-stuck', !entry.isIntersecting)
          );
          this.observer.observe(trigger);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('offerings-section')) {
  customElements.define('offerings-section',
    class OfferingsSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const blocks = this.querySelectorAll('[data-block-index]');
        const images = this.querySelectorAll('[data-image-index]');

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const block = entry.target;
            const index = block.getAttribute('data-block-index');
            if (index == 1) return;
            const image = this.querySelector(`[data-image-index="${index}"]`);
            if (!image) return;

            if (entry.isIntersecting && entry.intersectionRatio > 0) {
              image.setAttribute('data-visible', '');
            } else if (entry.boundingClientRect.top > 0) {
              image.removeAttribute('data-visible');
            }
          });
        }, {
          threshold: 0.5
        });

        blocks.forEach(block => this.observer.observe(block));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pets"]) return;
  try {
    
  if (!customElements.get("pet-carousel")) {
    customElements.define(
      "pet-carousel",
      class PetCarousel extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute("data-section-id");
        }

        connectedCallback() {
          this.swiperEl = this.querySelector("swiper-container");
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          const targetSlide = this.querySelector(`#${event.detail.sectionId}-${event.detail.blockId}`);
          const targetIndex = parseInt(targetSlide.getAttribute("data-index"));
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener("shopify:block:deselect", this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.swiperEl.swiper.slideTo(0, 0);
        }

        disconnectedCallback() {
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener("shopify:block:select", this.onBlockSelect);
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('press-marquee')) {
    customElements.define(
      'press-marquee',
      class PressMarquee extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          if (Shopify.designMode) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.setAttribute('data-block-selected', '');
          event.target.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.removeAttribute('data-block-selected');
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
          document.dispatchEvent(new CustomEvent('theme:recommendations:loaded'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-feed')) {
    customElements.define(
      'social-feed',
      class SocialFeed extends HTMLElement {
        constructor() {
          super();
          this.observer = null;
          this.feedChildrenCount = 0;
        }

        connectedCallback() {
          const instaFeed = this.querySelector('#insta-feed');
          if (!instaFeed) return;

          this.observer = new MutationObserver((mutationsList) => {
            // console.log('Insta feed mutated', mutationsList[0]);
            const addedNodes = mutationsList[0].addedNodes;
            const container = Array.from(addedNodes)
              .filter((node) => node.tagName === 'DIV')[0]
              .querySelector('.instafeed-new-layout-wrapper');
            // console.log('Container:', container);
            this.setupMarquee(container);
            this.dispatchEvent(new CustomEvent('insta-feed:mutated', { detail: mutationsList }));
            this.observer.disconnect();
          });

          this.observer.observe(instaFeed, {
            childList: true,
            subtree: false,
          });
        }

        setupMarquee(container) {
          if (!container) return;

          const children = Array.from(container.children);
          if (children.length === 0) return;

          children.forEach((child) => {
            const imgs = child.querySelectorAll('img[data-instafeed-src]');
            imgs.forEach((img) => {
              if (img.dataset.instafeedSrc) {
                img.src = img.dataset.instafeedSrc;
              }
            });
          });

          container.innerHTML = '';

          for (let i = 0; i < 2; i++) {
            const track = document.createElement('div');
            track.className = 'instafeed-marquee__track';
            const wrapper = document.createElement('div');
            wrapper.className = 'instafeed-marquee__wrapper';
            const flex = document.createElement('div');
            flex.className = 'instafeed-marquee__flex';

            children.forEach((child) => flex.appendChild(child.cloneNode(true)));

            wrapper.appendChild(flex);
            track.appendChild(wrapper);
            container.appendChild(track);
          }
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-carousel')) {
    customElements.define(
      'testimonials-carousel',
      class TestimonialsCarousel extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute('data-section-id');
        }

        connectedCallback() {
          this.swiperEl = this.querySelector('swiper-container');
          if (Shopify.designMode && this.swiperEl) {
            document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
          }
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          const targetSlide = this.querySelector(`#${event.detail.sectionId}-${event.detail.blockId}`);
          const targetIndex = parseInt(targetSlide.getAttribute('data-index'));
          console.log(targetIndex);
          this.swiperEl.swiper.slideTo(targetIndex, 0);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this), { once: true });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.sectionId) return;
          this.swiperEl.swiper.slideTo(0, 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
